import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import moment from 'moment';
import React from 'react';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import AccountPayableListModal from '@/components/_common/AccountPayableListModal';
import { InstallmentSituation } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import DashboardStatisticCard from '../../DashboardStatisticCard';

interface Props {
  value?: number;
}

const PayablePayDayQuantity: React.FC<Props> = ({ value }) => {
  const [viewAccountPayablesOpen, viewAccountPayablesActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Quantidade de parcelas pagas hoje."
        statisticTitle="Pagas | Qtde."
        color={StatisticDashboardTypeColor.expense}
        value={value}
        module={StatisticDashboardModule.accountPayable}
        onClick={viewAccountPayablesActions.open}
      />

      <AccountPayableListModal
        open={viewAccountPayablesOpen}
        onCancel={viewAccountPayablesActions.close}
        queryFilter={{
          situation: InstallmentSituation.settled,
          payDate: moment().format(DateTimeFormat),
        }}
      />
    </>
  );
};

export default PayablePayDayQuantity;
